import { render, staticRenderFns } from "./HostedPaymentPagePreview.vue?vue&type=template&id=37315a48&"
import script from "./HostedPaymentPagePreview.vue?vue&type=script&lang=ts&"
export * from "./HostedPaymentPagePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports